import { useReactiveVar } from "@apollo/client";
import { CampaignShort } from "@coral/typings";
import { TableRow } from "@gfg/ui/components/table";
import { createUseStyles } from "@gfg/ui/theming";
import { useNavigate, useParams, Link } from "react-router-dom";
import TitleSubtitleCell from "common/components/table/cells/title-subtitle-cell";
import reactiveVariables from "common/graphql/global-reactive-variables";
import date from "../../../../common/services/dates";
import { useDeleteCampaignMutation } from "../../../../generated";
import ActionCell from "../cells/action-cell";

export interface CollapsibleRowProps {
  campaign: CampaignShort;
  index: number;
}

const useStyles = createUseStyles(({ colors }) => ({
  rowGrey: {
    background: colors.lightergray,
  },
  rowLight: {
    background: colors.white,
  },
  iconButton: {
    height: 0,
    paddingLeft: 0,
  },
  uuidContainer: {
    color: colors.gray,
    cursor: "pointer",
  },
}));

export default function CollapsibleRow({ campaign, index }: CollapsibleRowProps) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { region } = useParams();
  const selectedEnvironmentProjectId = useReactiveVar(reactiveVariables.selectedEnvironmentIdVar);

  const [deleteCampaign] = useDeleteCampaignMutation({ refetchQueries: ["GetCampaigns"] });

  return (
    <TableRow key={campaign.id} className={index % 2 === 0 ? classes.rowGrey : classes.rowLight}>
      <TitleSubtitleCell
        title={<Link to={`/${region}/campaigns/edit/${campaign.id}`}>{campaign.name.slice(0, 60)}</Link>}
        subtitle={<span>[Campaign ID] {campaign.externalId}</span>}
      />
      {campaign.modifiedBy ? (
        <TitleSubtitleCell
          title={campaign.modifiedBy}
          subtitle={date.format(date.fromSecondsSinceEpoch(campaign.updatedAt))}
        />
      ) : (
        <TitleSubtitleCell
          title={campaign.createdBy}
          subtitle={date.format(date.fromSecondsSinceEpoch(campaign.createdAt))}
        />
      )}
      <ActionCell
        onDuplicate={() => navigate(`/${region}/campaigns/duplicate/${campaign.id}`)}
        onEdit={() => navigate(`/${region}/campaigns/edit/${campaign.id}`)}
        onDelete={() =>
          deleteCampaign({
            variables: { input: { campaignId: campaign.id, projectId: selectedEnvironmentProjectId } },
          })
        }
      />
    </TableRow>
  );
}
